import { ParticipateBoxProps } from "./ParticipateFormBox";

export const INVOLVEDCONFIG: ParticipateBoxProps[] = [
  // {
  //   name: "Artists",
  //   bodyText:
  //     "Sign up below if you would like to sell your work at WreckCon 2026 and you do not have a business license. Tabling space for artists is totally free, but unfortunately not guaranteed.",
  //   link: "https://forms.gle/AYxp3roTTNr2cW4f6",
  //   buttonText: "Artist Intake",
  //   color: "#659470",
  //   isOpen: true
  // },
  // {
  //   name: "Vendors",
  //   bodyText:
  //     "If you are a seller with a business license interested in WreckCon 2026, please fill out the form below! Please note that as per Georgia Tech policy, tabling as a vendor will incur a $300 fee.",
  //   link: "https://forms.gle/49npviDD7znRQkx17",
  //   buttonText: "Vendor Intake",
  //   color: "#FF7F41",
  //   isOpen: true

  // },
  // {
  //   name: "Pretty Derby",
  //   bodyText:
  //     "If you are interested in participating in WreckCon: Pretty Derby, please sign up by Wednesday, October 22nd by filling out the form below.",
  //   link: "https://docs.google.com/forms/d/e/1FAIpQLScOTT7RORpSsOjJ_dxOh6XH1hhplffrBIP_gnifT7MerUZ-Xw/viewform?usp=sharing",
  //   buttonText: "Pretty Derby Signup",
  //   color: "#FF7F41",
  //       isOpen: true

  // },
  {
    name: "RSO Intake",
    bodyText:
      "If you are interested in applying for membership in the WreckCon RSO, please fill out the form below.",
    link: "https://docs.google.com/forms/d/e/1FAIpQLScfVxvDfGG828S1f7wFYvsRQf1TXACiIqHUTBpIduh8U3bFww/viewform?usp=sharing",
    buttonText: "RSO Intake",
    color: "#FFC42D",
        isOpen: true

  },
  // {
  //   name: "Volunteers",
  //   bodyText:
  //     "We're always looking for help managing WreckCon. If you would like to help out and volunteer on the day of the of the convention, you can sign up here!",
  //   link: "https://forms.gle/vDX1tkFcRmaxYoQB9",
  //   buttonText: "Volunteer Intake",
  //   color: "#64A2FF",
  //       isOpen: false

  // },
  // {
  //   name: "Panelists",
  //   bodyText:
  //     "Have an idea or topic you're dying to share at WreckCon? Paneling space is completely free, but highly in-demand, so sign up as soon as you can!",
  //   link: "https://forms.gle/6rQ7WYve3vKbXWG47",
  //   buttonText: "Panelist Intake",
  //   color: "#A880FF",
  //       isOpen: false

  // },
  // {
  //   name: "Indie Games",
  //   bodyText:
  //     "If you would like to demo a video game or other interactive media at WreckCon, sign up below! Tabling space will be free, but is not guaranteed.",
  //   link: "https://forms.gle/vkA8NxT2YZVoWjFS8",
  //   buttonText: "Indie Games Intake",
  //   color: "#F04924",
  //       isOpen: false

  // },
];
